import React, { useEffect, useState, useContext } from 'react';
import './GHGEmissions.scss';
import { withTranslation } from 'react-i18next';
import { Button, Modal, Table, Form } from 'react-bootstrap';
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import ReactDatePicker from "react-datepicker";
import moment from "moment";

const AddCollectionData = ({ t, onShowModal, onHideModal, db, companyId, entity, glbRegulationId }) => {

    const { setLoaderDisplay } = useContext(LoaderContext);
    const [showModal, setShowModal] = useState(onShowModal);
    const [period, setPeriod] = useState(new Date());
    const [item, setItem] = useState('');
    const [supplier, setSupplier] = useState('');
    const [uom, setUom] = useState('');
    const [quantity, setQuantity] = useState('');
    const [costInUSD, setCostInUSD] = useState('');
    const [validated, setValidated] = useState(false);

    const editPurchasedItem = () => {
        setLoaderDisplay(true);
        GHGEmissionService.editCollectionItem(
            [{
                categoryName: "",
                code: "",
                costInUSD: costInUSD,
                factorId: "",
                factorWithMargins: "",
                id: null,
                item: item,
                period: moment(period).format('YYYY-MM-DD'),
                quantity: quantity,
                refUSEEIOCode: "",
                status: "FINALIZED",
                supplier: supplier,
                uom: uom
            }],
            db,
            companyId,
            entity,
            glbRegulationId
        ).then((response) => {
            setLoaderDisplay(false);
            onHideModal(false);
            toast.success("Data added successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidated(true);

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            toast.warning('Please fill all the mandatory fields');
        } else {
            editPurchasedItem();
        }
    }

    return (
        <div>
            <Modal className='CategorySearch_modal' show={showModal} onHide={() => onHideModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title as="h5">{t("AddNew.label")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='py-0 row'>
                    <div className='col-md-12 p-2'>
                        <div className="card mb-2">
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <div>
                                    <div className='p-2'>
                                        <label>Period <span className="text-danger">*</span></label>
                                        <ReactDatePicker
                                            selected={new Date(period)}
                                            className="form-control"
                                            required placeholder='Choose Date'
                                            onChange={(date) => { setPeriod(date) }}
                                            dateFormat="dd/MM/yyyy"
                                        />
                                    </div>
                                    <div className='p-2'>
                                        <label>Item <span className="text-danger">*</span></label>
                                        <input type='text' className='form-control' value={item} required placeholder='Provide Item'
                                            onChange={(e) => setItem(e.target.value)} />
                                    </div>
                                    <div className='p-2'>
                                        <label>Supplier <span className="text-danger">*</span></label>
                                        <input type='text' className='form-control' value={supplier} required placeholder='Provide Supplier'
                                            onChange={(e) => setSupplier(e.target.value)} />
                                    </div>
                                    <div className='p-2'>
                                        <label>UOM <span className="text-danger">*</span></label>
                                        <input className='form-control' value={uom} required placeholder='Provide UOM'
                                            onChange={(e) => setUom(e.target.value)} />
                                    </div>
                                    <div className='p-2'>
                                        <label>Quantity <span className="text-danger">*</span></label>
                                        <input type='number' className='form-control' value={quantity} required placeholder='Provide Quantity'
                                            onChange={(e) => setQuantity(e.target.value)} />
                                    </div>
                                    <div className='p-2'>
                                        <label>Cost in USD <span className="text-danger">*</span></label>
                                        <input type='number' className='form-control' value={costInUSD} required placeholder='Provide Cost'
                                            onChange={(e) => setCostInUSD(e.target.value)} />
                                    </div>
                                </div>
                                <div className='text-center p-2'>
                                    <button type="submit" className="btn btn-primary me-2">{t("Save.label")}</button>
                                    <button type="button" className="btn btn-secondary" onClick={() => onHideModal(false)}>{t("Close.label")}</button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default withTranslation()(AddCollectionData);